import chartTitles from '../chartTitles'
import withToolbar from '../withToolbar'
import LineChart from './LineChart'
import dayjs from 'dayjs'

const mobilityKey = {
  1: 'Very Poor',
  2: 'Poor',
  3: 'Average',
  4: 'Good',
  5: 'Very Good',
}

export default withToolbar(LineChart, {
  pdfExport: {
    title: chartTitles.mobility,
  },
  timeWindow: 7 * 4,
  childProps: {
    type: 'mobility',
    yMax: 5,
    yAllowDecimals: false,
    yAxisLabel: 'Mobility Score',
    title: chartTitles.mobility,
    subTitle: '1 = Very Poor, 2 = Poor, 3 = Average, 4 = Good, 5 = Very Good',
    tooltip: {
      formatter() {
        return `
                    <strong style="font-size: 10px; opacity: 0.7;">
                        ${dayjs(this.x).format('dddd Do MMMM YYYY')}
                    </strong>
                    <br />
                    Mobility was <strong>${mobilityKey[this.y]}</strong>`
      },
    },
  },
})
